import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Card, CardContent } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import { useSelector } from 'react-redux';
import { CommonConfig } from '../../config/common-config';
import ButtonComp from '../../components/button';
import './itecstyles.css';
import LoaderPopUp from '../../components/loaderpopup/loader';
import SuccessPopUp from '../../components/loaderpopup/success';
import ErrorPopUp from '../../components/loaderpopup/error';
import moment from 'moment';
import PreviewImage from '../../assets/previewImage.png';
import PreviewModal from '../../components/modal/previewModal';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles((theme) => ({
    submit: {
        margin: theme.spacing(3, 0, 2),
        background: '#f8961d',
        '&:hover': {
            background: '#fdac48',
        },
        border: '1px solid #ef8400',
        borderRadius: '5px',
        fontFamily: 'Rubik',
        width: '50%',
        color: '#fff',
    },
    centerAlign: {
        textAlign: 'center',
    },
    checked: {},

    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },

        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    pad: {
        paddingBottom: '30px',
        paddingLeft: '0',
        '&:last-child': {
            paddingBottom: '0px',
        },
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    textField: {
        borderBottom: '1px solid lightgrey !important',
    },
    disableBtn: {
        color: '#bbb !important',
        background: '#cecece !important',
        padding: '6px 40px !important',
        fontFamily: 'Rubik',
        textTransform: 'none !important',
    },
    btnFieldPositionRight: {
        position: 'absolute',
        right: '0',
        top: '20px',
    },
    uploadBtn: {
        width: '30px',
        fontSize: '10px !important',
        height: '20px',
        textTransform: 'capitalize',
        fontWeight: '400 !important',
    },
}));

export default function Itec(props) {
    const classes = useStyles();
    const [allRadios, setAllRadios] = useState([]);
    const [allStates, setAllStates] = useState([]);
    const [selectedFileData, setSelectedFileData] = useState(null);
    const [handleOpen, setHandleOpen] = useState(false);
    const [isDisable, setIsDisableUpload] = useState(true);
    const [isDisableAddFile, setIsDisableAddFile] = useState(true);
    const [isDisableClose, setIsDisableClose] = useState(true);
    const [isDisableCancel, setIsDisableCancel] = useState(true);
    const [isDisableSubmit, setIsDisableSubmit] = useState(true);
    const [filename, setFilename] = useState('');
    const [isfileInvalid, setIsfileInvalid] = useState('');
    const [clearData, setClearData] = useState('');
    const [fileuploadMsg, setFileuploadMsg] = useState('');
    const [fileuploadMsgError, setFileuploadMsgError] = useState([]);
    const [fileuploadMsg400Error, setFileuploadMsg400Error] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const [statusDiv, setStatusDiv] = useState('none');
    const [catchErrorDiv, setCatchErrorDiv] = useState('none');
    const [length, setLength] = useState('');
    const [lengthSuccess, setLengthSuccess] = useState('');
    // const [updateStat, setUpdateStat] = useState(false);
    const [errormsg, setErrormsg] = useState('');
    // const vertical = 'top';
    // const horizontal = 'center';
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    //console.log('length', length);
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails.tennantName;
    const [allCities, setAllCities] = useState([]);
    const [allCountries, setAllCountries] = useState([]);
    const [selectedCountry, setselectedCountry] = useState('');
    const [selectedState, setselectedState] = useState('');
    const [selectedStateId, setselectedStateId] = useState('');
    const [selectedCity, setselectedCity] = useState('');
    const [coreTeam, setCoreTeam] = useState([]);
    const [coreTeamRoles, setCoreTeamRoles] = useState([]);
    const coreRoleslist = [];
    const option = [];
    const [empRoles, setEmpRoles] = useState([]);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const axiosConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: bearerToken,
        },
    };
    const downloadformat = `${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=ConfigFiles/ITeC_employees_creation_format.xlsx`;
    const downloadDesignationlist = `${CommonConfig.dev.baseUrl}/api/auth/download_itechEmpDesign`;

    const [handleOpenPan, setHandleOpenPan] = useState(false);
    const [clearDataPan, setClearDataPan] = useState('');
    const [isfileInvalidPan, setIsfileInvalidPan] = useState('');
    const [selectedFileDataPan, setSelectedFileDataPan] = useState(null);
    const [filenamePan, setFilenamePan] = useState('');
    const [uploadSuccessfullyPan, setUploadSuccessfullyPan] = useState('');
    const [isDisablePan, setIsDisablePan] = useState(true);
    const [URLValuePan, setURLValuePan] = useState();

    const [handleOpenAadhar, setHandleOpenAadhar] = useState(false);
    const [clearDataAadhar, setClearDataAadhar] = useState('');
    const [isfileInvalidAadhar, setIsfileInvalidAadhar] = useState('');
    const [selectedFileDataAadhar, setSelectedFileDataAadhar] = useState(null);
    const [filenameAadhar, setFilenameAadhar] = useState('');
    const [uploadSuccessfullyAadhar, setUploadSuccessfullyAadhar] = useState('');
    const [isDisableAadhar, setIsDisableAadhar] = useState(true);
    const [URLValueAadhar, setURLValueAadhar] = useState();
    // const [URLValueEnrollment, setURLValueEnrollment] = useState();

    const [attachedFilePan, setAttachedFilePan] = useState('');
    const [attachedFileAadhar, setAttachedFileAadhar] = useState('');
    // const [attachedFileEnrollment, setAttachedFileEnrollment] = useState('');
    const [visible, setVisible] = React.useState(false);
    const [downloadFile, setDownloadFile] = useState('');
    const [showBtnLoader, setShowBtnLoader] = useState(false);

    const fetchCountryData = () => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/global/getCountries`, axiosConfig)
            .then((response) => {
                setAllCountries(response.data);
            })
            .catch(() => {});
    };
    const fetchStateData = (data) => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/global/country/${data}/getStates`, axiosConfig)
            .then((response) => {
                setAllStates(response.data);
            })
            .catch(() => {});
    };
    const fetchCityData = (data) => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/global/state/${data}/getCities`, axiosConfig)
            .then((response) => {
                setAllCities(response.data);
            })
            .catch(() => {});
    };
    const fetchStateId = (country, state) => {
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/state-country/${dbname}?state=${state}&country=${country}`, '', axiosConfig)
            .then((response) => {
                setselectedStateId(response.data.state.id);
            });
    };
    const setCountry = (e) => {
        setselectedCountry(e.target.value);
        fetchStateData(e.target.value);
    };
    const setState = (e) => {
        setselectedState(e.target.value);
        fetchCityData(e.target.value);
        fetchStateId(selectedCountry, e.target.value);
    };
    const setCity = (e) => {
        setselectedCity(e.target.value);
    };
    const handleClick = () => {
        setHandleOpen(true);
        setClearData('');
        setIsDisableClose(false);
        setIsDisableCancel(true);
        setIsDisableAddFile(false);
        setFilename('');
    };

    const handleClose = () => {
        setHandleOpen(false);
        setIsDisableUpload(true);
        setIsDisableSubmit(true);
        setIsfileInvalid('');
        setFilename(null);
        setStatusDiv('none');
        setCatchErrorDiv('none');
        setShowLoader(false);
    };

    const handleClosePan = () => {
        setHandleOpenPan(false);
        setIsfileInvalidPan('');
        setUploadSuccessfullyPan('');
    };
    const handleClickPan = () => {
        setHandleOpenPan(true);
        setFilenamePan('');
        setClearDataPan('');
        setIsDisablePan(true);
    };
    const isFileUploadPan = (event, selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(xlsx|xls|csv|png|jpeg|jpg|pdf|zip)$');
            setFilenamePan(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalidPan('');
                setIsDisablePan(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalidPan('Please select the file size less than 10MB');
                    setIsDisablePan(true);
                } else {
                    setSelectedFileDataPan(selectorFiles[0]);
                }
            } else {
                setIsfileInvalidPan('Please select valid file format i.e xlsx/xls/csv');
                setIsDisablePan(true);
            }
        }
    };
    const fileUploadPan = () => {
        const data = new FormData();
        data.append('file', selectedFileDataPan);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${dbname}/myimage`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data) {
                    setURLValuePan(response.data);
                    setAttachedFilePan(filenamePan);
                    setUploadSuccessfullyPan('Uploaded a file successfully');
                    setTimeout(() => {
                        handleClosePan();
                    }, 500);
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setIsDisablePan(true);
                }
            });
    };

    const handleModalClose = () => {
        setVisible(false);
    };

    const handlePreviewModal = (file) => {
        setDownloadFile(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`);
        setShowBtnLoader(true);
        setTimeout(() => {
            setShowBtnLoader(false);
            setVisible(true);
        }, 1000);
    };

    const handleCloseAadhar = () => {
        setHandleOpenAadhar(false);
        setIsfileInvalidAadhar('');
        setUploadSuccessfullyAadhar('');
    };
    const handleClickAadhar = () => {
        setHandleOpenAadhar(true);
        setClearDataAadhar('');
        setFilenameAadhar('');
        setIsDisableAadhar(true);
    };
    const isFileUploadAadhar = (event, selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(xlsx|xls|csv|png|jpeg|jpg|pdf|zip)$');
            setFilenameAadhar(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalidAadhar('');
                setIsDisableAadhar(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalidAadhar('Please select the file size less than 10MB');
                    setIsDisableAadhar(true);
                } else {
                    setSelectedFileDataAadhar(selectorFiles[0]);
                }
            } else {
                setIsfileInvalidAadhar('Please select valid file format i.e xlsx/xls/csv');
                setIsDisableAadhar(true);
            }
        }
    };
    const fileUploadAadhar = () => {
        const data = new FormData();
        data.append('file', selectedFileDataAadhar);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${dbname}/myimage`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data) {
                    setURLValueAadhar(response.data);
                    setAttachedFileAadhar(filenameAadhar);
                    setUploadSuccessfullyAadhar('Uploaded a file successfully');
                    setTimeout(() => {
                        handleCloseAadhar();
                    }, 500);
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setIsDisableAadhar(true);
                }
            });
    };

    const formik = useFormik({
        initialValues: {
            firstname: '',
            lastname: '',
            fathersname: '',
            gender: '',
            dob: '',
            addressline1: '',
            addressline2: '',
            city: '',
            state: '',
            country: '',
            pin: '',
            emergencynumber: '',
            pan: '',
            personalemail: '',
            mobilenumber: '',
            aadharnumber: '',
            officemailid: '',
            branch: '',
            timeSheetApprover: '',
            doj: '',
            confirmationdate: '',
            designation: '',
        },
        validationSchema: Yup.object().shape({
            firstname: Yup.string().label('FirstName').required('Required Field'),
            lastname: Yup.string().label('LastName').required('Required Field'),
            fathersname: Yup.string().label('FathersName').required('Required Field'),
            gender: Yup.string().required('Please Select'),
            dob: Yup.date().max(new Date(), 'Date of Birth should not be a future date').required('Please Enter your Date Of Birth'),
            // .test('dob', 'You must be 18 or older', (dobValue) => {
            //     const cutOff = new Date();
            //     cutOff.setFullYear(cutOff.getFullYear() - 18);
            //     return dobValue <= cutOff;
            // }),
            addressline1: Yup.string().required('Please Enter your Address').max(1000, 'Max 1000 characters or less'),
            addressline2: Yup.string().required('Please Enter your Address').max(1000, 'Max 1000 characters or less'),
            city: Yup.string()
                .matches(/^[aA-zZ ]+$/, 'Enter a Valid City')
                .required('Required Field'),
            state: Yup.string().ensure().required('State Required Field'),
            country: Yup.string()
                .matches(/^[aA-zZ ]+$/, 'Enter a Valid Country')
                .required('Required Field'),
            pin: Yup.string()
                .matches(/^\d{4,6}$/, 'Enter a valid PIN')
                .required('Please enter your PinCode'),
            emergencynumber: Yup.string()
                // .matches(/^[0-9]{10,12}$/, 'Enter vaild mobile number')
                .matches(/^\+[1-9]{1}[0-9]{4,11}$/, 'Enter vaild mobile number with valid Country code')
                .required('Enter Mobile Number'),
            pan: Yup.string()
                .matches(/^[aA-zZ]{5}[0-9]{4}[aA-zZ]{1}$/, 'Enter Valid PAN')
                .required('PAN is Mandatory'),
            personalemail: Yup.string()
                .matches(/^[a-zA-Z0-9._-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,63}$/, 'Enter Valid Email')
                .email('Invalid Email Format')
                .required('Required Field'),
            mobilenumber: Yup.string()
                // .matches(/^[0-9]{10,12}$/, 'Enter vaild mobile number')
                .matches(/^\+[1-9]{1}[0-9]{4,11}$/, 'Enter vaild mobile number with valid Country code')
                .required('Mobile number is Mandatory'),
            aadharnumber: Yup.string()
                .matches(/^\d{4}\d{4}\d{4}$/, 'Enter Valid 12 digit Aadhaar Number')
                .required('Aadhaar Number is Mandatory'),
            officemailid: Yup.string()
                .matches(/^[a-zA-Z0-9._-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,63}$/, 'Enter Valid Email')
                .email('Invalid email format')
                .required('Required Field'),
            branch: Yup.string(),
            // .matches(/^[A-z0-9 ]+$/i, 'Enter a Valid branch Name')
            // .min('2', 'Please Enter atleast 2 words'),
            // .required('Required Field'),
            designation: Yup.string().required('Please Select One Of Designations'),
            timeSheetApprover: Yup.string().ensure().required('Please select Approver'),
            doj: Yup.date().max(new Date(), 'Date of joining should not be a future date').required('Please Enter Date Of Joining'),
            confirmationdate: Yup.date().min(Yup.ref('doj'), 'Confirmation date should not be prior to date of joining'),
            // .max(Yup.ref('doj'), 'Should Match Date Of Joining')
            // .required('Confirm Date Of Joining')
        }),
        onSubmit: (values) => {
            setShowLoader(true);
            window.scrollTo(0, 0);
            const data = {
                firstName: values.firstname,
                adressId: {
                    addressLine1: values.addressline1,
                    addressLine2: values.addressline2,
                    city: selectedCity,
                    stateId: {
                        id: selectedStateId,
                    },
                    pinCode: values.pin,
                    country: selectedCountry,
                },
                pan: values.pan,
                aadharNumber: values.aadharnumber,
                lastName: values.lastname,
                officeEmail: values.officemailid,
                mobileNumber: values.mobilenumber,
                fathersName: values.fathersname,
                gender: values.gender,
                dateOfBirth: values.dob,
                personalEmail: values.personalemail,
                doj: values.doj,
                confirmationDate: values.confirmationdate,
                branch: values.branch,
                designation: {
                    roleId: Number(values.designation),
                },
                emergencyNumber: values.emergencynumber,
                approverForTimesheet: values.timeSheetApprover,
                panFiles: URLValuePan && URLValuePan.length ? URLValuePan : '',
                aadhaarFiles: URLValueAadhar && URLValueAadhar.length ? URLValueAadhar : '',
            };

            // console.log("data", data);

            axios
                .post(`${CommonConfig.dev.baseUrl}/api/auth/s_itec_employee`, data, axiosConfig)
                .then((response) => {
                    setShowLoader(false);
                    setSuccess(true);
                    setTimeout(() => {
                        props.history.push('/menu/itechView');
                    }, 3000);
                })
                .catch((error) => {
                    const errResult = error.response;
                    if (errResult.data) {
                        setShowLoader(false);
                        setError(true);
                        setTimeout(() => {
                            setError(false);
                        }, 5000);
                        setErrorMsgGenerateRecceipt(errResult.data.message);
                    }
                });
        },
    });
    const history = useHistory();

    useEffect(() => {
        setTimeout(() => {
            axios
                .get(`${CommonConfig.dev.baseUrl}/api/auth/get-all-designation`, axiosConfig)
                .then((response) => {
                    if (response) {
                        setAllRadios(response.data);
                        response.data.map((ele, i) => {
                            if (ele.roleId <= 8) {
                                coreRoleslist.push(ele);
                                setCoreTeamRoles(coreRoleslist);
                            }
                        });
                    }
                })
                .catch(() => {});
        }, 1000);

        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s_itec_employee?page=0&size=1000&sort=itecEmpId,desc`, axiosConfig)
            .then((response) => {
                if (response) setCoreTeam(response.data.content);
            })
            .catch(() => {});

        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/get-itecAMandAbove`, axiosConfig)
            .then((response) => {
                if (response) setEmpRoles(response.data);
            })
            .catch(() => {});
        fetchCountryData();
    }, [userToken]);

    const allCountryOptions = (ww) => {
        const OptionList = ww.map((data) => <option value={data.country_name}>{data.country_name}</option>);
        return OptionList;
    };

    const allStateOptions = (ww) => {
        const OptionList = ww.map((data) => <option value={data.state_name}>{data.state_name}</option>);
        return OptionList;
    };
    const allCityOptions = (ww) => {
        const OptionList = ww.map((data) => <option value={data.city_name}>{data.city_name}</option>);
        return OptionList;
    };
    const allRadioOptions = (qq) => {
        const radioList = qq.map((number) => (
            //  <Grid item xs={12} sm={3} className={classes.pad}>
            <Grid item xs={12} sm={3} className={classes.pad}>
                <input
                    id={number.roleText}
                    type="radio"
                    value={number.roleId}
                    name="designation"
                    onChange={formik.handleChange}
                    defaultChecked={formik.values.designation === number.roleText}
                />
                <label className="custom-control-label" htmlFor={number.roleText}>
                    {number.roleText}
                </label>
            </Grid>
        ));

        return <div className="itecdesg-radiosdiv">{radioList}</div>;
    };

    const toInputUppercase = (e) => {
        e.target.value = ('' + e.target.value).toUpperCase();
    };

    const fileUpload = () => {
        setShowLoader(true);
        const data = new FormData();
        data.append('file', selectedFileData);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/upload_itechemployee`, data, axiosConfig)
            .then((response) => {
                if (response.data) {
                    setIsDisableUpload(true);
                    setIsDisableClose(false);
                    setIsDisableCancel(true);
                    setIsDisableAddFile(true);
                    setIsDisableSubmit(false);
                    const failure = [];
                    setShowLoader(false);
                    {
                        response.data.map((row, index) => {
                            if (row.status) {
                                failure.push({ email: row.userEmail, status: row.status, message: row.errormessage });
                                setStatusDiv('block');
                            }
                        });
                    }
                    setFileuploadMsgError(failure);
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setCatchErrorDiv('block');
                    setShowLoader(false);
                    setIsDisableUpload(true);
                    setIsDisableClose(false);
                    setIsDisableAddFile(false);
                    setIsDisableCancel(true);
                    setIsDisableSubmit(true);
                    setFileuploadMsg400Error(`${error.response.data.error} : ${error.response.data.message}`);
                }
            });
    };

    const getRoles = () => {};

    const allCoreEmployeeOptions = () => {
        if (empRoles) {
            const OptionList = empRoles.map((data) => (
                <option value={data.id + ' - ' + data.firstName + ' ' + data.lastName}>
                    {data.id} - {data.firstName} {data.lastName}
                </option>
            ));
            return OptionList;
        }
    };

    const isFileUpload = (event, selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(xlsx|xls|csv)$');
            setFilename(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalid('');
                setIsDisableUpload(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalid('Please select the file size less than 10MB');
                    setIsDisableUpload(true);
                } else {
                    setSelectedFileData(selectorFiles[0]);
                    setIsDisableClose(true);
                    setIsDisableCancel(false);
                    setIsDisableAddFile(false);
                }
            } else {
                setIsfileInvalid('Please select valid file format i.e xlsx/xls/csv');
                setIsDisableUpload(true);
            }
        }
    };

    const back = () => {
        props.history.push('/menu/itechView');
    };

    return (
        <>
            {success ? (
                <SuccessPopUp open={success} showSuccess={success} handleClose={handleClose} title="ITeC employee created successfully" />
            ) : null}
            {error ? <ErrorPopUp open={error} showError={error} handleClose={handleClose} title={errorMsgGenerateRecceipt} /> : null}

            <form className="itecform" onSubmit={formik.handleSubmit}>
                <Card className="client-card">
                    <CardContent className="client-heading">
                        <Typography variant="h5">Create Employee for ITeC Team</Typography>
                    </CardContent>
                    <CardContent>
                        <Grid container spacing={3} className="main-container">
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="firstname" shrink>
                                        {' '}
                                        First Name <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        name="firstname"
                                        type="text"
                                        placeholder="Enter Name"
                                        className="bottom"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.firstname}
                                    />
                                    {formik.touched.firstname && formik.errors.firstname ? (
                                        <span className="itec-validationError">{formik.errors.firstname}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="lastname" shrink>
                                        {' '}
                                        Last Name <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Name"
                                        className="bottom"
                                        name="lastname"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.lastname}
                                    />
                                    {formik.touched.lastname && formik.errors.lastname ? (
                                        <span className="itec-validationError">{formik.errors.lastname}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="fathersname" shrink>
                                        {' '}
                                        Father&apos;s Name <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Name"
                                        className="bottom"
                                        name="fathersname"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.fathersname}
                                    />
                                    {formik.touched.fathersname && formik.errors.fathersname ? (
                                        <span className="itec-validationError">{formik.errors.fathersname}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="gender" shrink>
                                        {' '}
                                        Gender <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Select
                                        native
                                        onChange={formik.handleChange}
                                        inputProps={{
                                            name: 'gender',
                                        }}
                                        className="bottom"
                                        onBlur={formik.handleBlur}
                                    >
                                        <option value="">Select Gender</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                    </Select>
                                    {formik.touched.gender && formik.errors.gender ? (
                                        <span className="itec-validationError">{formik.errors.gender}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="dob" shrink>
                                        {' '}
                                        Date of Birth <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <TextField
                                        type="date"
                                        name="dob"
                                        margin="normal"
                                        format="DD/MM/YYYY"
                                        className={classes.textField}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.dob}
                                        // inputProps={{ max: "9999-12-31" }}
                                        InputProps={{ inputProps: { max: moment(new Date()).format('DD-MM-YYYY') } }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {formik.touched.dob && formik.errors.dob ? (
                                        <span className="itec-validationError">{formik.errors.dob}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="addressline1" shrink>
                                        {' '}
                                        Address line 1 <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Address"
                                        className="bottom"
                                        name="addressline1"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.addressline1}
                                    />
                                    {formik.touched.addressline1 && formik.errors.addressline1 ? (
                                        <span className="itec-validationError">{formik.errors.addressline1}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="addressline2" shrink>
                                        {' '}
                                        Address line 2 <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Address"
                                        className="bottom"
                                        name="addressline2"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.addressline2}
                                    />
                                    {formik.touched.addressline2 && formik.errors.addressline2 ? (
                                        <span className="itec-validationError">{formik.errors.addressline2}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="country" shrink>
                                        {' '}
                                        Country <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Select
                                        native
                                        onChange={(e) => {
                                            setCountry(e);
                                            formik.handleChange(e);
                                        }}
                                        name="country"
                                        className="bottom"
                                        onBlur={formik.handleBlur}
                                        value={selectedCountry}
                                    >
                                        <option value="">Select Country</option>
                                        {allCountryOptions(allCountries)}
                                    </Select>
                                    {formik.touched.country && formik.errors.country ? (
                                        <span className="itec-validationError">{formik.errors.country}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="state" shrink>
                                        {' '}
                                        State <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Select
                                        native
                                        className="bottom"
                                        name="state"
                                        value={selectedState}
                                        onChange={(e) => {
                                            setState(e);
                                            formik.handleChange(e);
                                        }}
                                        onBlur={formik.handleBlur}
                                    >
                                        <option value="">Select State</option>
                                        {allStateOptions(allStates)}
                                    </Select>
                                    {formik.touched.state && formik.errors.state ? (
                                        <span className="itec-validationError">{formik.errors.state}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="city" shrink>
                                        {' '}
                                        City <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>

                                    <Select
                                        native
                                        name="city"
                                        className="bottom"
                                        value={selectedCity}
                                        onChange={(e) => {
                                            setCity(e);
                                            formik.handleChange(e);
                                        }}
                                        onBlur={formik.handleBlur}
                                    >
                                        <option value="">Select City</option>
                                        {allCityOptions(allCities)}
                                    </Select>
                                    {formik.touched.city && formik.errors.city ? (
                                        <span className="itec-validationError">{formik.errors.city}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="pin" shrink>
                                        {' '}
                                        Pin <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Pin"
                                        className="bottom"
                                        maxLength="6"
                                        name="pin"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.pin}
                                    />
                                    {formik.touched.pin && formik.errors.pin ? (
                                        <span className="itec-validationError">{formik.errors.pin}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="emergencynumber" shrink>
                                        {' '}
                                        Emergency Number <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Emergency Number"
                                        className="bottom"
                                        name="emergencynumber"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.emergencynumber}
                                    />
                                    {formik.touched.emergencynumber && formik.errors.emergencynumber ? (
                                        <span className="itec-validationError">{formik.errors.emergencynumber}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="pan" shrink>
                                        {' '}
                                        PAN <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        onInput={toInputUppercase}
                                        type="text"
                                        placeholder="Enter PAN"
                                        className="bottom"
                                        name="pan"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.pan}
                                    />

                                    <div className={classes.btnFieldPositionRight}>
                                        <span style={{ marginRight: '7px' }} className="fileName">
                                            {attachedFilePan}
                                        </span>
                                        {attachedFilePan ? (
                                            <span onClick={() => handlePreviewModal(URLValuePan)}>
                                                <Tooltip title="Preview">
                                                    <img src={PreviewImage} alt="PreviewImage" className="fileView" />
                                                </Tooltip>
                                            </span>
                                        ) : null}
                                        <Button onClick={handleClickPan} variant="outlined" color="primary" className={classes.uploadBtn}>
                                            Upload<span style={{ color: '#ff0a047a' }}>*</span>
                                        </Button>
                                        <Dialog
                                            onClose={handleClosePan}
                                            PaperProps={{
                                                className: 'QandADailogBox',
                                                style: { padding: '20px' },
                                            }}
                                            aria-labelledby="form-dialog-title"
                                            open={handleOpenPan}
                                            clear={clearDataPan}
                                        >
                                            <DialogTitle id="form-dialog-title">
                                                Upload File
                                                {/* <IconButton
                                                    aria-label="close"
                                                    className={classes.closeButton}
                                                    onClick={handleClosePan}
                                                >
                                                    <CloseIcon />
                                                </IconButton> */}
                                            </DialogTitle>
                                            <DialogContent style={{ textAlign: 'center' }}>
                                                <Button className="btnOrange" variant="outlined" component="label" color="default">
                                                    <i className="btnIcon">
                                                        <FontAwesomeIcon icon={faPlus} />
                                                    </i>{' '}
                                                    Add File
                                                    <input
                                                        onChange={(e) => isFileUploadPan(e, e.target.files)}
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        accept=".jpeg,.png,.csv,.zip,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                    />
                                                </Button>
                                                <p className="fileName">{filenamePan}</p>
                                                {filenamePan ? (
                                                    isfileInvalidPan.length > 0 ? (
                                                        <p className="noteCss">Note: {isfileInvalidPan}</p>
                                                    ) : (
                                                        ''
                                                    )
                                                ) : null}
                                            </DialogContent>
                                            <p className="fileNameGreen">{uploadSuccessfullyPan}</p>
                                            <DialogActions className="paddingBtm txtCenter">
                                                <Button
                                                    className={isDisablePan ? classes.disableBtn : 'btnBluepop'}
                                                    onClick={fileUploadPan}
                                                    variant="contained"
                                                    disabled={isDisablePan}
                                                    component="label"
                                                    color="default"
                                                >
                                                    Upload
                                                </Button>
                                                <Button
                                                    className="btnBluepop"
                                                    onClick={handleClosePan}
                                                    variant="contained"
                                                    component="label"
                                                    color="default"
                                                >
                                                    Cancel
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </div>
                                    {formik.touched.pan && formik.errors.pan ? (
                                        <span className="itec-validationError">{formik.errors.pan}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="personalemail" shrink>
                                        {' '}
                                        Personal E-mail <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Personal E-mail"
                                        className="bottom"
                                        name="personalemail"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.personalemail}
                                    />
                                    {formik.touched.personalemail && formik.errors.personalemail ? (
                                        <span className="itec-validationError">{formik.errors.personalemail}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="mobilenumber" shrink>
                                        {' '}
                                        Mobile Number <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Mobile Number"
                                        className="bottom"
                                        name="mobilenumber"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.mobilenumber}
                                    />
                                    {formik.touched.mobilenumber && formik.errors.mobilenumber ? (
                                        <span className="itec-validationError">{formik.errors.mobilenumber}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="aadharnumber" shrink>
                                        {' '}
                                        Aadhaar Number <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Aadhaar Number"
                                        className="bottom"
                                        name="aadharnumber"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.aadharnumber}
                                    />
                                    <div className={classes.btnFieldPositionRight}>
                                        <span style={{ marginRight: '7px' }}>{attachedFileAadhar}</span>
                                        {attachedFileAadhar ? (
                                            <span onClick={() => handlePreviewModal(URLValueAadhar)}>
                                                <Tooltip title="Preview">
                                                    <img src={PreviewImage} alt="PreviewImage" className="fileView" />
                                                </Tooltip>
                                            </span>
                                        ) : null}
                                        <label htmlFor="raised-button-file">
                                            <Button
                                                onClick={handleClickAadhar}
                                                // variant="raised"
                                                // component="span"
                                                color="primary"
                                                variant="outlined"
                                                className={classes.uploadBtn}
                                                // endIcon={<AttachFileIcon />}
                                            >
                                                Upload<span style={{ color: '#ff0a047a' }}>*</span>
                                            </Button>
                                        </label>

                                        <Dialog
                                            onClose={handleCloseAadhar}
                                            PaperProps={{
                                                className: 'QandADailogBox',
                                                style: { padding: '20px' },
                                            }}
                                            aria-labelledby="form-dialog-title"
                                            open={handleOpenAadhar}
                                            clear={clearDataAadhar}
                                        >
                                            <DialogTitle id="form-dialog-title">
                                                Upload File
                                                {/* <IconButton
                                                                aria-label="close"
                                                                className={classes.closeButton}
                                                                onClick={handleCloseAadhar}
                                                            >
                                                                <CloseIcon />
                                                            </IconButton> */}
                                            </DialogTitle>
                                            <DialogContent style={{ textAlign: 'center' }}>
                                                <Button className="btnOrange" variant="outlined" component="label" color="default">
                                                    <i className="btnIcon">
                                                        <FontAwesomeIcon icon={faPlus} />
                                                    </i>{' '}
                                                    Add File
                                                    <input
                                                        onChange={(e) => isFileUploadAadhar(e, e.target.files)}
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        accept=".jpeg,.png,.csv,.zip,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                    />
                                                </Button>
                                                <p className="fileName">{filenameAadhar}</p>
                                                {filenameAadhar ? (
                                                    isfileInvalidAadhar.length > 0 ? (
                                                        <p className="noteCss">Note: {isfileInvalidAadhar}</p>
                                                    ) : (
                                                        ''
                                                    )
                                                ) : null}
                                            </DialogContent>
                                            <p className="fileNameGreen">{uploadSuccessfullyAadhar}</p>
                                            <DialogActions className="paddingBtm txtCenter">
                                                <Button
                                                    className={isDisableAadhar ? classes.disableBtn : 'btnBluepop'}
                                                    onClick={fileUploadAadhar}
                                                    variant="contained"
                                                    disabled={isDisableAadhar}
                                                    component="label"
                                                    color="default"
                                                >
                                                    Upload
                                                </Button>
                                                <Button
                                                    className="btnBluepop"
                                                    onClick={handleCloseAadhar}
                                                    variant="contained"
                                                    component="label"
                                                    color="default"
                                                >
                                                    Cancel
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </div>
                                    {formik.touched.aadharnumber && formik.errors.aadharnumber ? (
                                        <span className="itec-validationError">{formik.errors.aadharnumber}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="officemailid" shrink>
                                        {' '}
                                        Office Mail-Id <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Office Mail-Id"
                                        className="bottom"
                                        name="officemailid"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.officemailid}
                                    />
                                    {formik.touched.officemailid && formik.errors.officemailid ? (
                                        <span className="itec-validationError">{formik.errors.officemailid}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="branch" shrink>
                                        {' '}
                                        Branch
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Branch"
                                        className="bottom"
                                        name="branch"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.branch}
                                    />
                                    {formik.touched.branch && formik.errors.branch ? (
                                        <span className="itec-validationError">{formik.errors.branch}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="timeSheetApprover" shrink>
                                        {' '}
                                        Approver for Timesheet, Leaves, Time in-out <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    {/* <Input
                        value={formik.values.timeSheetApprover}
                        onChange={formik.handleChange}
                        className="bottom selectHeight"
                        helperText="Approver for Timesheet, Leaves, Time in-out"
                        variant="filled"
                        
                        onBlur={formik.handleBlur}/> */}

                                    <Select
                                        native
                                        onChange={formik.handleChange}
                                        onClick={getRoles}
                                        inputProps={{
                                            name: 'timeSheetApprover',
                                        }}
                                        className="bottom"
                                        onBlur={formik.handleBlur}
                                    >
                                        {/* <option value="">Select Approver</option> */}
                                        {/* <option value="a">a</option>
                                        <option value="b">b</option>
                                        <option value="c">c</option>
                                        <option value="d">d</option> */}
                                        <option value="">Select Approver</option>
                                        {allCoreEmployeeOptions()}
                                    </Select>
                                    {formik.touched.timeSheetApprover && formik.errors.timeSheetApprover ? (
                                        <span className="itec-validationError">{formik.errors.timeSheetApprover}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            {/* <option value="" selected>
                    Time Sheet Approver
                </option>
                <option value="a">a</option>
                <option value="b">b</option>
                <option value="c">c</option>
                <option value="d">d</option>
            </select> */}

                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="doj" shrink>
                                        {' '}
                                        Date of Joining <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <TextField
                                        id="doj"
                                        name="doj"
                                        type="date"
                                        margin="normal"
                                        format="DD/MM/YYYY"
                                        className={classes.textField}
                                        // className="itecInputBox itec-datebox"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.doj}
                                        // inputProps={{ max: "9999-12-31" } }
                                        InputProps={{ inputProps: { max: moment(new Date()).format('DD-MM-DD') } }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {formik.touched.doj && formik.errors.doj ? (
                                        <span className="itec-validationError">{formik.errors.doj}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="confirmationdate" shrink>
                                        {' '}
                                        Confirmation Date
                                    </InputLabel>
                                    <Input
                                        id="confirmationdate"
                                        name="confirmationdate"
                                        type="date"
                                        className="bottom"
                                        // className="itecInputBox itec-datebox"
                                        inputProps={{ max: '9999-12-31' }}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.confirmationdate}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {formik.touched.confirmationdate && formik.errors.confirmationdate ? (
                                        <span className="itec-validationError">{formik.errors.confirmationdate}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <div className="designdiv">
                                        <div className="designtext">
                                            Designation<span style={{ color: '#ff0a047a' }}>*</span>{' '}
                                        </div>
                                        <div className="dividerdiv" />
                                    </div>
                                </FormControl>
                                <div className="itecform-radiodiv">
                                    <div className="itecradiosmaindiv">
                                        {allRadioOptions(allRadios)}
                                        {formik.touched.designation && formik.errors.designation ? (
                                            <span className="itec-validationError">{formik.errors.designation}</span>
                                        ) : null}
                                    </div>
                                </div>
                            </Grid>
                        </Grid>

                        {/* <div className="itecform-radiodiv"> */}
                        {/* <div className="designdiv"> */}
                        {/* <div className="designtext">Designation</div> */}
                        {/* <div className="dividerdiv"> */}
                        {/* <hr className="dividertag" /> */}
                        {/* </div> */}

                        {/* <div className="itecradiosmaindiv">
                            {allRadioOptionsOld(allRadios)}
                            {formik.touched.designation && formik.errors.designation ? (
                                <span className="itec-validationError">{formik.errors.designation}</span>
                            ) : null}
                        </div> */}
                    </CardContent>
                </Card>
                <Grid>
                    <div className="footer-button">
                        <ul>
                            <li>
                                <div className="errorMsgRed">{errormsg}</div>
                                {/* {(showBtnLoader && (
                                    <Button color="primary" className="txt-capitalize butnImp buttonnext" disabled>
                                        <CircularProgress size={20} />
                                    </Button>
                                )) || (
                                    <Button color="primary" type="submit" className="txt-capitalize buttonnext">
                                        Create Employee
                                    </Button>
                                )} */}
                                {(showLoader ? (
                                    <LoaderPopUp
                                        showLoader={showLoader}
                                        handleClose={handleClose}
                                        title="Please wait while we create the employee"
                                    />
                                ) : null) || <ButtonComp type="submit" className="intermediarybutn" title="Create Employee" />}
                            </li>
                        </ul>
                    </div>
                </Grid>

                {/* <div className="createintermediary-btndiv">
                    {(showBtnLoader && (
                        <Button variant="outlined" className="butn butnImp" disabled>
                            <CircularProgress style={{ color: '#F8951B' }} size={20} />
                        </Button>
                    )) || <ButtonComp type="submit" className="intermediarybutn" title="Create Employee" />}       
            </div> */}
            </form>

            <div className="divideritecmaindiv dividermargin">
                <div className="divideritecdiv1">
                    <hr className="dividertag" />
                </div>
                <div className="designtext">OR</div>
                <div className="divideritecdiv1">
                    <hr className="dividertag" />
                </div>
            </div>
            <form className="itecform">
                <Card className="client-card">
                    <CardContent className="client-heading">
                        <span className="heading"> Upload Employees Detail </span>
                    </CardContent>

                    <CardContent>
                        <Grid container spacing={12} className="main-container" style={{ placeContent: 'flex-start' }}>
                            {/* <Grid item xs={12} sm={4}>
                                <FormControl fullWidth className="intermediarybtnfontsize">
                                    <a
                                        href={downloadformat}
                                        download="itech_employee_format.csv"
                                        className="underline"
                                    >
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            component="span"
                                            color="primary"
                                            className="intermediarybtn"
                                            title="Download format"
                                        >
                                            Download format
                                        </Button>
                                    </a>
                                    <span className="itec-downloadtext">Download sample format for onboarding employees</span>
                                </FormControl>
                            </Grid> */}
                            <div style={{ padding: '5px' }}>
                                Click on the <a href={downloadformat}>link to download an empty employee list file</a> as an excel
                                spreadsheet. Fill up the excel spreadsheet with list of employee. Use &#8220;File &#8211;&#062; Save
                                as&#8221; options to save as .CSV.
                            </div>

                            {/* <Grid item xs={12} sm={4}>
                                <FormControl fullWidth className="intermediarybtnfontsize">
                                    <a href={downloadDesignationlist} download="itech_employee_designation.csv" className="underline">
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            component="span"
                                            color="primary"
                                            className="intermediarybtn"
                                            title="Download format for designation list"
                                        >
                                            Download format for designation list
                                        </Button>
                                    </a>
                                </FormControl>
                            </Grid> */}
                        </Grid>

                        <Grid item xs={12} sm={12}>
                            <div className="mt-15">
                                <span style={{ color: '#ff0a047a' }}>*</span>Please note: Approver for Timesheet, Leaves , Time in-out value
                                should match the values in the drop down.
                            </div>
                        </Grid>

                        {/* <Grid
                            item
                            container spacing={12}
                            className="intermediarybtnfontsize itec-bottombtndiv"
                            style={{ placeContent: 'flex-start' }}
                        >

                        </Grid> */}
                        <Grid item xs={12} sm={5}>
                            <FormControl fullWidth>
                                <div className="intermediarybtnfontsize" style={{ paddingLeft: '12px !important' }}>
                                    <span className="sucessMsg">{fileuploadMsg}</span>
                                    {/* <span className="sucessMsg">{fileuploadMsgError}</span> */}

                                    {/* <input accept="image/*" style={{ display: 'none' }} id="raised-button-file" multiple type="file" /> */}
                                    <label htmlFor="raised-button-file">
                                        <div
                                            style={{
                                                fontWeight: '500',
                                                placeContent: 'flex-start',
                                                paddingBottom: '10px',
                                                color: '#5d5d5d',
                                            }}
                                        >
                                            Upload list of employee in CSV format
                                        </div>
                                        <Button
                                            startIcon={<AttachFileIcon />}
                                            onClick={handleClick}
                                            variant="outlined"
                                            component="span"
                                            color="primary"
                                            className="intermediarybtn"
                                        >
                                            Attach Updated Document
                                        </Button>
                                    </label>
                                    <Dialog
                                        onClose={handleClose}
                                        PaperProps={{
                                            className: 'QandADailogBox',
                                            style: { padding: '20px' },
                                        }}
                                        aria-labelledby="form-dialog-title"
                                        // eslint-disable-next-line react/destructuring-assignment
                                        open={handleOpen}
                                        clear={clearData}
                                        // disableBackdropClick
                                    >
                                        <DialogTitle id="form-dialog-title">
                                            Upload File
                                            {/* <IconButton
                                                    aria-label="close"
                                                    className={classes.closeButton}
                                                    onClick={handleClose}
                                                    // onClick={onClose}
                                                >
                                                    <CloseIcon />
                                                </IconButton> */}
                                        </DialogTitle>
                                        <DialogContent style={{ textAlign: 'center' }}>
                                            <DialogContentText>Upload the updated employee list</DialogContentText>

                                            <Button
                                                className="btnOrange"
                                                disabled={isDisableAddFile}
                                                variant="outlined"
                                                component="label"
                                                color="default"
                                            >
                                                <i className="btnIcon">
                                                    <FontAwesomeIcon icon={faPlus} />
                                                </i>{' '}
                                                Add File
                                                <input
                                                    onChange={(e) => isFileUpload(e, e.target.files)}
                                                    type="file"
                                                    style={{ display: 'none' }}
                                                    accept=".csv,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                />
                                            </Button>
                                            <p className="fileNameGreen">{filename}</p>
                                            <p className="errorMsg">{isfileInvalid}</p>
                                            <div style={{ display: catchErrorDiv }}>
                                                <p className="errorMsg">{fileuploadMsg400Error}</p>
                                            </div>
                                            <p className="errorMsg">{lengthSuccess}</p>
                                            <p className="errorMsg">{length}</p>
                                        </DialogContent>

                                        <DialogActions className="paddingBtm txtCenter">
                                            {(showLoader && (
                                                <div className={classes.centerAlign} style={{ width: '18%' }}>
                                                    <Button className="submit btnOrange" variant="outlined" fullWidth disabled>
                                                        <CircularProgress size={24} />
                                                    </Button>
                                                </div>
                                            )) || (
                                                <Button
                                                    className={isDisable ? classes.disableBtn : 'btnBluepop'}
                                                    onClick={fileUpload}
                                                    variant="contained"
                                                    disabled={isDisable}
                                                    component="label"
                                                    color="default"
                                                >
                                                    {/* <i className="btnIcon">
                                                    <FontAwesomeIcon icon={faUpload} />
                                                </i>{' '} */}
                                                    Upload
                                                </Button>
                                            )}
                                            <Button
                                                className="btnBluepop"
                                                // disabled={isDisableCancel}
                                                onClick={handleClose}
                                                variant="contained"
                                                component="label"
                                                color="default"
                                            >
                                                {/* <i className="btnIcon">
                                            <FontAwesomeIcon icon={faBan} />
                                        </i>{' '} */}
                                                Cancel
                                            </Button>

                                            {/*                                     
                                    <Button
                                        className="btnOrange"
                                        onClick={handleClose}
                                        disabled={isDisableClose}
                                        variant="contained"
                                        component="label"
                                        color="default" >
                                        <i className="btnIcon">
                                            <FontAwesomeIcon icon={faBan} />
                                        </i>{' '}
                                        Close
                                    </Button> */}
                                        </DialogActions>
                                        <div className="statusTbl" style={{ display: statusDiv }}>
                                            <TableContainer className="container fontRubik">
                                                <Table stickyHeader aria-label="sticky table" className="popFonts">
                                                    <TableHead className="fontRubik">
                                                        <TableRow>
                                                            <TableCell>Sl No</TableCell>
                                                            <TableCell>User Email</TableCell>
                                                            <TableCell>Status</TableCell>
                                                            <TableCell>Message</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {fileuploadMsgError.map((row, index) => (
                                                            <TableRow hover role="checkbox">
                                                                <TableCell>{index + 1}</TableCell>
                                                                <TableCell>{row.email}</TableCell>
                                                                <TableCell>{row.status}</TableCell>
                                                                <TableCell>
                                                                    {row.status === 'SUCCESS' ? 'SUCCESS' : row.message.join(',\n')}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </div>
                                    </Dialog>
                                </div>
                            </FormControl>
                        </Grid>

                        <div className="itec-finalsubmitbtnmain itec-fullWidth">
                            {/* <div className="itec-finalsubmitbtn ">
                                <Link to="/menu/itechView">
                                    {(showLoader ? (
                                        <LoaderPopUp
                                            showLoader={showLoader}
                                            disabled={isDisableSubmit}
                                            handleClose={handleClose}
                                            title="Please wait while we create the employee"
                                        />
                                    ) : null) || <ButtonComp type="submit" className="intermediarybutn" title="Submit" />}
                                </Link>
                            </div> */}
                            <PreviewModal fileSource={downloadFile} visibleClose={visible} handleModalClose={handleModalClose} />
                            {showBtnLoader ? (
                                <LoaderPopUp
                                    showLoader={showBtnLoader}
                                    handleClose={handleClose}
                                    title="Please wait while approving Draft Statements"
                                />
                            ) : null}
                        </div>
                    </CardContent>
                </Card>
            </form>
            <Button variant="contained" onClick={() => back()} className="btnBlue txt-cap btnBckFloat" color="primary">
                Back
            </Button>
        </>
    );
}
